module.exports = __webpack_public_path__ + "static/media/home-madit.33c81601.jpg";